$shm_hitalama_map_book $mol_book2
	placeholders /
	menu_title <= title \
	history_open? null
	pages /
		<= Page $shm_hitalama_map_book_page
			map_id <= map_context \
			title <= title
			sub <= page_sub /
				<= Head $shm_hitalama_map_head
					map <= map
					zoom? <=> zoom?
					shift? <=> shift?
					map_cut <= map_cut null
					widget_headers_visible? => widget_headers_visible?
					widget_list_visible? => widget_list_visible?
					rights_visible? => rights_visible?
					drawing_tools_visible? => drawing_tools_visible?
					file_list_visible? => file_list_visible?
					editor_mode_enabled? => editor_mode_enabled?
					arrows_visible? => arrows_visible?
					history_open? <=> history_open?
				- <= Tool_modes
				^ widget_list_view /
					<= Widgets $shm_hitalama_map_book_widgets3
						map <= map
						Map_page <= Map_page
						editor_mode_enabled <= editor_mode_enabled
						widget_list_visible? <=> widget_list_visible?
				^ map_or_editor /
					<= Map_page $shm_hitalama_map_page
						entity <= entity $giper_baza_entity
						cut <= map_cut null
						map => map
						zoom? => zoom?
						shift? => shift?
						widgets_filtered => widgets_filtered
						selected_links => selected_links
						- Open_in_new null
						go_to_widget* => go_to_widget*
						Widget* => Widget*
						widget_headers_visible <= widget_headers_visible
						arrows_visible <= arrows_visible
						tool_mode? <=> tool_mode?
						Widget_props <= Widget_props
					<= Floating_tools $shm_hitalama_map_book_tools_float
						Map_page <= Map_page
						tool_mode? <=> tool_mode?
					<= Editor $shm_hitalama_map_editor
						map <= map
						widget <= widget_for_editor null
						Widget* <= Widget*
		^ widget_props_visible /
			<= Widget_props $shm_hitalama_map_widget_page
				widget <= widget_for_settings null
				Map_page <= Map_page
	Tool_modes $shm_hitalama_map_book_tools
		tool_mode? <=> tool_mode? \
		style *
			left <= tool_modes_left \18rem
	Presets_page $shm_hitalama_map_widget_presets_page
		Map_page <= Map_page
	Access_denied $shm_hitalama_resilience_page
		title \Доступ к карте закрыт
		message \Попросите владельца карты выдать вам права доступа.
		retry_visible false
	Failure_page* $shm_hitalama_resilience_page
		title <= failure_title* \Карта временно недоступна
		message <= failure_message* \Не удалось загрузить карту. Остальные разделы продолжают работать.
		details <= failure_details* \
		retry_visible <= failure_retry_visible* true
	Widgets_visible $mol_check_icon
		checked? <=> widget_list_visible?
		Icon <= Widgets_visible_icon $mol_icon_format_list_bulleted
	Rights $mol_page
		title \Права доступа
		tools /
			<= Rights_close $mol_button_minor
				hint \Закрыть права доступа
				click? <=> rights_close? null
				sub / <= Rights_close_icon $mol_icon_close
		body /
			<= Rights_form $shm_hitalama_map_rights
				map <= map
				team? <=> rights_team? null
